import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsElement } from './tabs.component';
import { createCustomElement } from '@angular/elements';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TranslocoModule } from '@jsverse/transloco';
import { BadgeModule } from '@bazis/shared/components/web/badge/badge.module';
import { TabBtnModule } from '@bazis/shared/components/web/tabs/tab-btn/tab-btn.module';

@NgModule({
    declarations: [TabsElement],
    imports: [CommonModule, IconModule, TranslocoModule, BadgeModule, TabBtnModule],
    exports: [TabsElement],
})
export class TabsModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(TabsElement, {
            injector: this.injector,
        });

        customElements.define('bazis-tabs', el);
    }
}
